import AnalyticsPreference from "@/components/AnalyticsPreference";
import { Seo } from "@/components/Seo";
import { Reveal, HoldingsWordmark, SectionTitle } from "@/components/primitives";

const S = ({ n, title, children }) => (
  <Reveal>
    <div className="mb-8">
      <h2 className="font-display uppercase tracking-wide2 text-base md:text-lg gold-text">{title}</h2>
      <div className="mt-3 space-y-3 text-[var(--bone)]/85 leading-relaxed">{children}</div>
    </div>
  </Reveal>
);

export default function Privacy() {
  return (
    <div className="glow-black jmh-page">
      <Seo title="Privacy Policy" description="Privacy Policy for Jennae Michelle Holdings LLC." />
      <section className="jmh-section jmh-page-opening">
        <div className="mx-auto jmh-reading-shell">
          <Reveal className="text-center mb-8">
            <h1 className="font-display uppercase tracking-wide2 gold-text mb-8">Privacy Policy</h1>
            <HoldingsWordmark size="md" />
          </Reveal>
        </div>
      </section>

      <section className="jmh-section">
        <div className="mx-auto border border-[rgba(180,139,63,0.18)] px-6 md:px-10 py-10 jmh-reading-shell">
          <Reveal>
            <p className="text-[var(--bone)]/85 mb-8">
              <strong className="font-display uppercase tracking-wide2 text-sm gold-text">Privacy Policy</strong><br />
              Last updated: October 4, 2026<br />Company Name: Jennae Michelle Holdings LLC
            </p>
          </Reveal>

          <S n="1" title="Information We Collect">
            <p>When you interact with the website or its services, we may collect the contact information listed below:</p>
            <ul className="list-disc pl-6 space-y-1"><li>Name</li><li>Phone number</li><li>Email address (if provided)</li></ul>
            <p>We may also collect information you voluntarily submit, including property details and the circumstances described in an inquiry.</p>
            <p>This includes messaging data associated with your communications with us.</p>
          </S>
          <S n="2" title="How We Use Your Information">
            <p>The information collected supports the following purposes:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Respond to inquiries and provide requested services</li>
              <li>Communicate with you via SMS or other channels</li>
              <li>Provide customer support</li>
              <li>Improve our services and user experience</li>
            </ul>
          </S>
          <S n="3" title="SMS Communications">
            <p>Providing a phone number alone does not enroll you in marketing or automated text messages. If SMS communications are offered, we request the applicable consent separately.</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Message frequency varies based on interaction</li>
              <li>Message and data rates may apply</li>
              <li>You can opt out at any time by replying STOP</li>
              <li>You can request help by replying HELP</li>
            </ul>
          </S>
          <S n="4" title="Data Sharing">
            <p>We do not sell, rent, or share your personal information with third parties for marketing purposes.</p>
            <p>Information may be shared with service providers necessary to business operations, including messaging platforms, solely to the extent required for those services.</p>
          </S>
          <S n="5" title="Data Security">
            <p>We use reasonable safeguards to protect the information entrusted to us. Internet transmission cannot be guaranteed to be entirely secure.</p>
          </S>
          <S n="6" title="Your Rights">
            <p>You may:</p>
            <ul className="list-disc pl-6 space-y-1"><li>Request access to your data</li><li>Request deletion of your data</li><li>Opt out of communications at any time</li></ul>
          </S>
          <S title="Website Statistics and Browser Storage">
            <p>We count public page views, visits clicked to portfolio companies, phone and email link clicks, and completed contact forms. These statistics contain only a date, public page path, event type, company name where relevant, and a count. They do not contain your contact details, inquiry text, a visitor identifier, browsing profile, or session recording. Query strings are not collected. Aggregate statistics expire after 90 days.</p>
            <p>We use no analytics or advertising cookies for these counts. We honor Do Not Track and Global Privacy Control signals, and you may opt out below. Essential browser storage supports sign-in, page-scroll restoration, and your privacy preference. Hosting and security providers may process ordinary connection logs, including IP addresses, for website delivery and abuse prevention. Fonts may be loaded from Google Fonts.</p>
            <AnalyticsPreference />
          </S>
          <S title="Inquiry Handling and Retention">
            <p>Contact form submissions include your name, email address, organization if supplied, and message. They are stored in the restricted Founder Office inbox so we can review and respond to the inquiry. An email notification may also be sent to admin@jennaemichelle.com when a delivery service is configured. Please do not send confidential medical, legal, or financial records through the public contact form.</p>
            <p>We retain inquiry records only as needed for review, communication, operational recordkeeping, and applicable legal obligations. You can request access, correction, or deletion by emailing admin@jennaemichelle.com. Retention obligations may limit what can be deleted. We do not use inquiry details for website analytics or sell them.</p>
          </S>
          <S n="7" title="Changes to This Policy">
            <p>Revisions to this Privacy Policy will be published on this page as the policy is updated.</p>
          </S>
          <S n="8" title="Contact Information">
            <p>If you have questions, contact us at:</p>
            <p>Email: <a href="mailto:admin@jennaemichelle.com" className="gold-text link-underline">admin@jennaemichelle.com</a></p>
          </S>
        </div>
      </section>
    </div>
  );
}
